import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import {
  NgApexchartsModule,
  ApexChart,
  ApexNonAxisChartSeries,
  ApexLegend,
  ApexPlotOptions,
  ApexDataLabels,
  ApexFill
} from "ng-apexcharts";

import { CoreService } from "../../../services/core.service";

export interface RetentionChartOptions {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  plotOptions: ApexPlotOptions;
  dataLabels: ApexDataLabels;
  fill: ApexFill;
  legend: ApexLegend;
}

@Component({
  selector: 'app-social-ai-retention-chart',
  standalone: true,
  imports: [NgApexchartsModule],
  templateUrl: './social-ai-retention-chart.component.html',
  styleUrl: './social-ai-retention-chart.component.scss'
})
export class SocialAiRetentionChartComponent implements OnChanges {

  @Input() selectedSiteId: number | null = null;
  @Input() selectedPlatformId: number | null = null;
  @Input() selectedPeriod: string | null = null;

  @Input() pages: any[] = [];
  @Input() title: string = "";

  companyID: number | null = null;

  percent = 0;
  avgWatch = "– avg-watch";
  avgLength = "– avg. length";

  noData = false;

  public chartOptions: RetentionChartOptions = {
    series: [0, 100],
    chart: { type: "donut", height: 280 },
    labels: ["Watched", "Not Watched"],
    plotOptions: {
      pie: {
        donut: {
          size: "75%",
          labels: { show: false }
        }
      }
    },
    dataLabels: { enabled: false },
    fill: { colors: ["#3b82f6", "#d1d5db"] },
    legend: { show: false }
  };

  constructor(private coreService: CoreService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.companyID = this.coreService.user?.companyID || 0;

    if (this.companyID && this.selectedSiteId && this.selectedPlatformId && this.selectedPeriod) {
      this.loadRetentionData();
    }
  }

  loadRetentionData(): void {
    const url = `getretention/${this.companyID}`;

    const body = {
      company_id: this.companyID,
      contentsite_id: this.selectedSiteId,
      social_platform_id: this.selectedPlatformId,
      period: this.selectedPeriod
    };

    this.coreService.postData(url, body).subscribe({
      next: (res) => {

        if (Array.isArray(res) && res.length === 0) {
          this.setNoData();
          return;
        }

        const platformKey = String(this.selectedPlatformId);
        const platformData = res[platformKey];

        if (!platformData) {
          this.setNoData();
          return;
        }

        const firstTag = Object.keys(platformData)[0];
        const metrics = platformData[firstTag];

        if (!metrics) {
          this.setNoData();
          return;
        }

        this.noData = false;
        this.percent = metrics.retention_rate ?? 0;
        this.avgWatch = `${this.percent.toFixed(1)}% avg-watch`;
        this.avgLength = `${metrics.total_views || 0} total views`;

        this.chartOptions = {
          ...this.chartOptions,
          series: [this.percent, 100 - this.percent]
        };
      },

      error: () => this.setNoData()
    });
  }

  setNoData() {
    this.noData = true;
    this.percent = 0;
    this.avgWatch = "No data available";
    this.avgLength = "";
    this.chartOptions = {
      ...this.chartOptions,
      series: [0, 100]
    };
  }
}
